import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import { categories as defaultCategories } from "./constants";

export default function RateCategoryPickerModal({ onClose, onSelect, hasExistingCharges = false, categories = defaultCategories }) {
  return (
    <Dialog open maxWidth="xs" fullWidth onClose={onClose}>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography fontWeight={500} fontSize={18} color="text.primary" align="center">
          Ancillary Charge Type
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={1}>
          {categories.map(cat => (
            <Button key={cat.key} variant="outlined" onClick={() => onSelect(cat.key)}>
              {cat.title}
            </Button>
          ))}
          
          {!hasExistingCharges && (
            <>
              <Divider sx={{ my: 1 }} />
              <Button 
                variant="outlined" 
                onClick={() => onSelect("noAdditionalCharges")}
                sx={{ 
                  borderColor: "grey.400", 
                  color: "grey.700",
                  "&:hover": {
                    borderColor: "grey.600",
                    backgroundColor: "grey.50"
                  }
                }}
              >
                No Ancillary Charges
              </Button>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
